import React, { ReactNode, useCallback, useContext } from "react";
import Menu from "./Menu";
import MenuContext from "./context/menuContext";
import DropdownItem from "./DropdownItem";
import PropTypes from "prop-types";
import classNames from "classnames";

export interface DropdownMenuProps {
  id?: string;
  title?: string | ReactNode;
  eventKey?: string;
  activeKey?: string;
  onToggle?: (key, e) => void;
  className?: string;
  placement?: string;
  icon?: ReactNode;
  trigger?: string;
  children?: any;
  style?: any;
  hidden?: boolean;
  onSelect?: (key, e) => void;
}

const DropdownMenu = React.forwardRef<any, DropdownMenuProps>((props, ref) => {
  const { onToggle, eventKey, title, className, placement, ...rest } = props;

  const parentMenu = useContext(MenuContext);

  const handleToggleSubmenu = useCallback(
    (_, e) => {
      onToggle?.(eventKey, e);
    },
    [eventKey, onToggle]
  );

  const dropdownMenuDefaultClass = `dropdown-menu`;
  const dropdownMenuPositionClass = placement;

  const dropdownMenuClass = classNames(
    dropdownMenuDefaultClass,
    dropdownMenuPositionClass,
    className
  );

  const dropdownSubmenuClass = classNames(
    dropdownMenuDefaultClass,
    "dropdown-submenu"
  );

  const dropdownSubmenu = (
    <Menu
      className={dropdownSubmenuClass}
      ref={ref}
      onToggle={handleToggleSubmenu}
      placement={placement}
      {...rest}
    />
  );

  if (parentMenu) {
    const { icon, trigger } = props;
    const itemClassName = classNames(className);

    return (
      <DropdownItem
        icon={icon}
        trigger={trigger}
        className={itemClassName}
        submenu={dropdownSubmenu}
        eventKey={eventKey}
      >
        {title}
      </DropdownItem>
    );
  }

  return (
    <Menu
      className={dropdownMenuClass}
      placement={placement}
      ref={ref}
      {...rest}
    />
  );
});

export default DropdownMenu;
